export const announcementPermissions = {
    add: "Home.Announcements.Add",
    editOwn: "Home.Announcements.EditOwn",
    editAll: "Home.Announcements.EditAll",
    deleteOwn: "Home.Announcements.DeleteOwn",
    deleteAll: "Home.Announcements.DeleteAll"
};
